import owd from 'owd/owd';

export default class Filter extends owd.Component {
	init() {
		this.button = this.$element.find('[data-filter-button]');
		this.categories = this.$element.find('[data-filter-categories]');
		// this.$controller = this.$element.find('[data-filter-controller]');
		this.sectionVideos = $('[data-section-bottom]');
		this.footer = this.dom.$body.find('.footer')
		this.movingSections = this.sectionVideos.add(this.footer);
		this.height = this.$element.outerHeight();
		this.categoriesHeight = this.categories.outerHeight();
		this.offsetTop = this.$element.offset().top;

		// console.log(this.movingSections);

		this.isOpen = false;

		this.setAbsolute();
		this.bind();
	}

	calcBeforeElement() {
		var addRule = (function(style){
		    var sheet = document.head.appendChild(style).sheet;
		    return function(selector, css){
		        var propText = Object.keys(css).map(function(p){
		            return p+":"+css[p]
		        }).join(";");
		        sheet.insertRule(selector + "{" + propText + "}", sheet.cssRules.length);
		    }
		})(document.createElement("style"));


		if (window.matchMedia('(max-width: 519px)').matches) {
			this.beforeHeight = this.$element.outerHeight() + $('.work-filter-categories').outerHeight() + 30;
		} else {
			this.beforeHeight = this.$element.outerHeight() + $('.work-filter-categories').outerHeight() + 60;
		}

		addRule(".work-filter.is-fixed.is-opened:before", {
		    height: `${this.beforeHeight}px`
		});
	}

	open() {
		if (!this.$element.hasClass('is-fixed')) {
			this.movingSections.css({
				transform: `none`
			});
		}

		this.$element.addClass('is-opened');

		this.calcBeforeElement();

		this.isOpen = true;
	}

	close() {
		if (!this.$element.hasClass('is-fixed')) {
			this.movingSections.css({
				transform: `translateY(${-this.categoriesHeight}px)`
			});
		}

		this.$element.removeClass('is-opened');
		this.isOpen = false;
	}

	calcMargin() {
		if (this.isOpen) {
			this.footer.css('margin-bottom', '');
		} else {
			this.footer.css('margin-bottom', -this.categoriesHeight);
		}
	}

	setAbsolute() {
		this.sectionVideos.css('margin-top', this.height);
		this.$element.removeClass('is-static');
	}

	bind() {
		this.on('domready ajaxload', this.dom.$window, () => {
			this.calcMargin();
			// this.close();
			this.open();
			// this.button.addClass('is-closed');
		})

		this.on('transitionend', this.sectionVideos, (e) => {
			if (e.target === this.sectionVideos[0]) {
				this.calcMargin()
			}
		})

		this.on('click', this.button, () => {
			this.sectionVideos.removeClass('has-no-transition');

			if (!this.isOpen) {
				this.button.removeClass('is-closed');
				this.open();
				this.button.text("Hide");
			} else {
				this.button.addClass('is-closed');
				this.close()
				this.button.text("Filter");
			}
			// this.sectionVideos.toggleClass('is-translated');
		});

		this.on('scroll', this.dom.$window, () => {
			// if (this.dom.$window.scrollTop() > this.offsetTop) {
			// 	this.$element.addClass('is-fixed');

			// 	this.movingSections.css({
			// 		transform: `translateY(${-this.categoriesHeight}px)`
			// 	});
			// } else {
			// 	this.$element.removeClass('is-fixed');
			// }


			let wScroll = this.dom.$window.scrollTop();
			let sectionOffset = this.sectionVideos.offset().top - 200;
			// console.log(this.sectionVideos.offset().top);
			// console.log(wScroll);

			if (this.$element.hasClass('is-opened') &&
			this.$element.hasClass('is-fixed')
			// && (wScroll > sectionOffset)
		) {
				this.close();
				this.button.addClass('is-closed');
				this.button.text("Filter");
			}
		});
	}
}

owd.registerComponent('filter', {
	component: Filter
});
